import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import App from './App';
import './styles/globals.css';

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// ============================================================
// Bootstrap Slug Saving — preserve org slug for post-logout redirect
// ============================================================
const RESERVED_PATHS = new Set([
  '/', '/auth', '/bankid-callback', '/keys', '/devices', '/history', '/profile',
]);

(function bootstrapSlug() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  const match = path.match(/^\/([a-z0-9-]+)$/);
  if (match && !RESERVED_PATHS.has(path)) {
    const slug = match[1];
    sessionStorage.setItem('last_slug_path', '/' + slug);
    (window as any).__BOOTSTRAP_SLUG__ = slug;
  }
})();

// ============================================================
// Suppress non-fatal AbortError from Supabase auth lock acquisition
// ============================================================
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  if (event.reason?.name === 'AbortError') {
    event.preventDefault();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
